import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { resetPassword } from '../redux/actions/auth';
import { useFormik } from 'formik';
import * as yup from 'yup';

import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { Alert, AlertTitle } from '@mui/material';
import { CircularProgress } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Copyright from '../components/Copyright';
import ProjectTitle from '../components/ProjectTitle';

const validationsForm = yup.object({
  password: yup
    .string()
    .min(8, 'Parola en az 8 karakter içermelidir.')
    .required('Parolanızı giriniz.'),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref('password')], 'Parolalar eşleşmiyor.')
    .required('Parolanızı doğrulayın.'),
});

const theme = createTheme();

const ResetPasswordPage = (props) => {
  const location = useLocation();
  const dispatch = useDispatch();

  const token = new URLSearchParams(location.search).get('resetPasswordToken');

  const [loading, setLoading] = useState(false);

  const { message } = useSelector((state) => state.authMessage);

  const formik = useFormik({
    initialValues: {
      password: '',
      confirmPassword: '',
    },
    validationSchema: validationsForm,
    onSubmit: (values) => {
      const { password } = values;

      setLoading(true);
      dispatch(resetPassword(password, token))
        .then(() => {
          props.history.push('/');
          window.location.reload();
        })
        .catch(() => {
          setLoading(false);
        });
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <Grid
        container
        component="main"
        sx={{
          verticalAlign: 'center',
          marginTop: '5%',
          marginBottom: '5%',
          alignContent: 'center',
          alignItems: 'center',
          justifyContent: 'center',
          alignSelf: 'center',
        }}
      >
        <Container component="main" maxWidth="xs">
          <CssBaseline />
          <Grid item component={Paper} elevation={6} square>
            <Box
              sx={{
                my: 8,
                mx: 4,
                marginTop: 8,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <ProjectTitle />
              <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
                <LockOutlinedIcon />
              </Avatar>
              {loading && (
                <CircularProgress
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mt: 2,
                    mb: 2,
                  }}
                />
              )}
              <Typography component="h1" variant="h5">
                Parolanızı Sıfırlayın
              </Typography>
              <Box
                component="form"
                onSubmit={formik.handleSubmit}
                noValidate
                sx={{ mt: 1 }}
              >
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  name="password"
                  label="Parola"
                  type="password"
                  id="password"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.password && Boolean(formik.errors.password)
                  }
                  helperText={formik.touched.password && formik.errors.password}
                />
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  name="confirmPassword"
                  label="Parolayı Doğrulayın"
                  type="password"
                  id="confirmPassword"
                  value={formik.values.confirmPassword}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.confirmPassword &&
                    Boolean(formik.errors.confirmPassword)
                  }
                  helperText={
                    formik.touched.confirmPassword &&
                    formik.errors.confirmPassword
                  }
                />
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{ mt: 3, mb: 2 }}
                >
                  Parolanızı Sıfırlayın
                </Button>
                {message && (
                  <Alert severity="error">
                    <AlertTitle>Bilgi</AlertTitle>
                    <strong>{message.message}</strong>
                  </Alert>
                )}
              </Box>
            </Box>
            <Copyright sx={{ mt: 8, mb: 4 }} />
          </Grid>
        </Container>
      </Grid>
    </ThemeProvider>
  );
};

export default ResetPasswordPage;
